import { Directive, ElementRef, OnInit, Optional } from '@angular/core';
import { DialogContainerComponent } from './dialog-container.component';

let titleUniqueId = 0;

/**
 * Directive that marks the dialog title element.
 * Sets up the aria-labelledby link between container and title.
 *
 * Usage: `<h2 appDialogTitle>Title</h2>`
 */
@Directive({
  selector: '[appDialogTitle], [app-dialog-title]',
  host: {
    class: 'dialog__title',
    '[id]': 'id',
  },
})
export class DialogTitleDirective implements OnInit {
  id = `app-dialog-title-${titleUniqueId++}`;

  constructor(
    private readonly elementRef: ElementRef<HTMLElement>,
    @Optional() private readonly container: DialogContainerComponent | null
  ) {}

  ngOnInit(): void {
    if (this.container) {
      this.container.ariaLabelledBy = this.id;
    }
  }
}
